// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/axios";
import type { StartLinkAuthLinkEmailStartPostMutationRequest, StartLinkAuthLinkEmailStartPostMutationResponse, StartLinkAuthLinkEmailStartPost401, StartLinkAuthLinkEmailStartPost409, StartLinkAuthLinkEmailStartPost422, StartLinkAuthLinkEmailStartPost429 } from "../models/emailAuthController/StartLinkAuthLinkEmailStartPost.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";

function getStartLinkAuthLinkEmailStartPostUrl() {
  const res = { method: 'POST', url: `/auth/link/email/start` as const }
  return res
}

/**
 * @description Start email linking flow for authenticated Telegram users.
 * Sends verification code to provided email address.
 * @summary Start Link
 * {@link /auth/link/email/start}
 */
export async function startLinkAuthLinkEmailStartPost(data: StartLinkAuthLinkEmailStartPostMutationRequest, config: Partial<RequestConfig<StartLinkAuthLinkEmailStartPostMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<StartLinkAuthLinkEmailStartPostMutationResponse, ResponseErrorConfig<StartLinkAuthLinkEmailStartPost401 | StartLinkAuthLinkEmailStartPost409 | StartLinkAuthLinkEmailStartPost422 | StartLinkAuthLinkEmailStartPost429>, StartLinkAuthLinkEmailStartPostMutationRequest>({ method : "POST", url : getStartLinkAuthLinkEmailStartPostUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}